jQuery(document).ready(function ($) {

  jQuery.fn.tableToCSV = function (options) {

    var clean_text = function (text) {
      text = text.replace(/"/g, '""');
      return '"' + text + '"';
    };

    var t = $(this);

    var settings = $.extend({
      fileName: t.attr('id'),
      timestamp: true,
      outputheaders: true,
      trSelector: '',
      tdExclude: ''
    }, options);
    console.log(settings);

    $(this).each(function () {
      var table = $(this);
      var caption = $(this).find('caption').text();
      var title = [];
      var rows = [];

      console.log('tr' + settings.trSelector);

      $(this).find('tr' + settings.trSelector).each(function () {
        var data = [];
        $(this).find('th').not(settings.tdExclude).each(function () {
          var text = clean_text($(this).text());
          title.push(text);
        });
        $(this).find('td').not(settings.tdExclude).each(function () {
          var text = clean_text($(this).text().trim());
          data.push(text);
        });
        data = data.join(",");
        rows.push(data);
      });
      title = title.join(",");
      rows = rows.join("\n");

      var csv = title + rows;
      var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      var download_link = document.createElement('a');
      download_link.href = uri;
      var ts = settings.timestamp ? "-" + new Date().getTime() : "";
      download_link.download = settings.fileName + ts + ".csv";
      document.body.appendChild(download_link);
      download_link.click();
      document.body.removeChild(download_link);
    });

  };

});

